import GalleryView from "../Components/GalleryView";
import VideoPlayer from "../Components/VideoPlayer";
import { Link } from "react-router-dom";
import "../css/vertical-carousel.css";
import Aos from "aos";
import CourseSlick from "../Components/CourseSlick";
import TestimonialSlick from "../Components/TestimonialSlick";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import img1 from "../assets/BannerImages/bannerImg1.jpeg";
import img2 from "../assets/BannerImages/bannerImg2.jpeg";
// import img3 from "../assets/BannerImages/bannerImg3.jpeg";
import img4 from "../assets/BannerImages/bannerImg4.jpeg";
import img5 from "../assets/BannerImages/bannerImg5.jpeg";
import img6 from "../assets/BannerImages/bannerImg6.jpeg";
import img7 from "../assets/BannerImages/bannerImg7.jpeg";
import img8 from "../assets/BannerImages/bannerImg8.jpeg";
import img9 from "../assets/BannerImages/bannerImg9.jpeg";
// import img10 from "../assets/BannerImages/bannerImg10.jpg";
// import img11 from "../assets/BannerImages/bannerImg11.JPG";
// import img12 from "../assets/BannerImages/bannerImg12.JPG";
// import img13 from "../assets/BannerImages/MIBS- Our Recruters.jpg";
import img13 from "../assets/trainingPlacement/ourmainnewreq.png";

import { Grid } from "@mui/material";
import NewsAnnouncementText from "../Components/home/eventCards/NewsAnnouncement";
import UpcomingEvents from "../Components/home/eventCards/UpcomingEvents";
import NoticeBoardText from "../Components/home/eventCards/NoticeBoard";
import bannerimg from "../assets/home/Banner Image.jpg";
// import VisibilityIcon from '@mui/icons-material/Visibility';
import LaptopMacIcon from "@mui/icons-material/LaptopMac";
import { useEffect, useRef } from "react";

import p1 from "../../src/assets/home/placed students/Adarsh Jadhav.png";
import p2 from "../../src/assets/home/placed students/Aman Gupta.png";
import p3 from "../../src/assets/home/placed students/Arpita zade.png";
import p4 from "../../src/assets/home/placed students/Chaitali Hole.png";
import p5 from "../../src/assets/home/placed students/Isha Patil.png";
import p6 from "../../src/assets/home/placed students/Kanhaiyya Goud.png";
import p7 from "../../src/assets/home/placed students/Mahesh Chitampalli.png";
import p8 from "../../src/assets/home/placed students/Mahesh Talreja.png";
import p9 from "../../src/assets/home/placed students/Mayuri Jagtap.png";
import p10 from "../../src/assets/home/placed students/Monali Deulkar.png";
import p11 from "../../src/assets/home/placed students/Parth Mahadik.png";
import p12 from "../../src/assets/home/placed students/Randhie Desai.png";
import p13 from "../../src/assets/home/placed students/Sarang Kale.png";
import p14 from "../../src/assets/home/placed students/Shraddha Raut.png";
import p15 from "../../src/assets/home/placed students/Shubham Chavan.png";
import p16 from "../../src/assets/home/placed students/Shubham Ingle.png";
import p17 from "../../src/assets/home/placed students/Suraj Yadav.png";
import p18 from "../../src/assets/home/placed students/Vishwajeet Sarge.png";
import p19 from "../../src/assets/home/placed students/Yuvraj Pharande.png";
import p20 from "../../src/assets/home/placed students/2.png";
import p21 from "../../src/assets/home/placed students/3.png";
import p22 from "../../src/assets/home/placed students/4.png";
import p23 from "../../src/assets/home/placed students/5.png";
import p24 from "../../src/assets/home/placed students/6.png";
import p25 from "../../src/assets/home/placed students/7.png";
import p26 from "../../src/assets/home/placed students/8.png";
import p27 from "../../src/assets/home/placed students/9.png";
import p28 from "../../src/assets/home/placed students/10.png";
import p29 from "../../src/assets/home/placed students/11.png";
import p30 from "../../src/assets/home/placed students/12.png";
import p31 from "../../src/assets/home/placed students/13.png";
import p32 from "../../src/assets/home/placed students/14.png";
import p33 from "../../src/assets/home/placed students/15.png";
import p34 from "../../src/assets/home/placed students/16.png";
import p35 from "../../src/assets/home/placed students/17.png";
import p36 from "../../src/assets/home/placed students/18.png";
import p37 from "../../src/assets/home/placed students/19.png";
import p38 from "../../src/assets/home/placed students/20.png";
import p39 from "../../src/assets/home/placed students/21.png";
import p40 from "../../src/assets/home/placed students/22.png";

Aos.init({
  duration: 1000,
});

// Multiple slides
let items = document.querySelectorAll(".cc .ccl");
items.forEach((el) => {
  const minPerSlide = 2;
  let next = el.nextElementSibling;
  for (var i = 1; i < minPerSlide; i++) {
    if (!next) {
      // wrap carousel by using first child
      next = items[0];
    }
    let cloneChild = next.cloneNode(true);
    el.appendChild(cloneChild.children[0]);
    next = next.nextElementSibling;
  }
});

const Home = () => {
  const scrollRef = useRef(null);

  // useEffect(() => {
  //   const container = scrollRef.current;
  //   if (!container) return;

  //   const scrollStep = 1; // pixels to scroll
  //   const scrollDelay = 30; // ms between scrolls

  //   const interval = setInterval(() => {
  //     if (
  //       container.scrollTop + container.clientHeight >=
  //       container.scrollHeight
  //     ) {
  //       container.scrollTop = 0; // Reset to top
  //     } else {
  //       container.scrollTop += scrollStep;
  //     }
  //   }, scrollDelay);

  //   return () => clearInterval(interval); // cleanup on unmount
  // }, []);

useEffect(() => {
  const scrollContainer = scrollRef.current;
  if (!scrollContainer) return;

  let animationFrameId;
  let isPaused = false;
  const scrollSpeed = 4;

  const scrollStep = () => {
    if (!isPaused) {
      scrollContainer.scrollLeft += scrollSpeed;
      if (scrollContainer.scrollLeft >= scrollContainer.scrollWidth / 2) {
        scrollContainer.scrollLeft = 0;
      }
    }
    animationFrameId = requestAnimationFrame(scrollStep);
  };

  const handleMouseEnter = () => (isPaused = true);
  const handleMouseLeave = () => (isPaused = false);

  scrollContainer.addEventListener("mouseenter", handleMouseEnter);
  scrollContainer.addEventListener("mouseleave", handleMouseLeave);
  animationFrameId = requestAnimationFrame(scrollStep);

  return () => {
    cancelAnimationFrame(animationFrameId);
    scrollContainer.removeEventListener("mouseenter", handleMouseEnter);
    scrollContainer.removeEventListener("mouseleave", handleMouseLeave);
  };
}, []);

  const images = [
    // img10,
    img1,
    img2,
    // img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img9,
    // img11,
    // img12,
    img13,
  ];

  const placedStudents = [
    p1,
    p2,
    p3,
    p4,
    p5,
    p6,
    p7,
    p8,
    p9,
    p10,
    p11,
    p12,
    p13,
    p14,
    p15,
    p16,
    p17,
    p18,
    p19,
    p20,
    p21,
    p22,
    p23,
    p24,
    p25,
    p26,
    p27,
    p28,
    p29,
    p30,
    p31,
    p32,
    p33,
    p34,
    p35,
    p36,
    p37,
    p38,
    p39,
    p40,
  ];

  return (
    <>
      {/* Carousel Images */}
      <div className="default-padding p-0 px-0">
        <div className="container-fluids">
          <div className="Image-Carousel">
            <Carousel
              autoPlay
              infiniteLoop
              showArrows={true}
              showThumbs={false}
            >
              {images.map((image, index) => (
                <div key={index} style={{ minWidth: "100%" }}>
                  <img src={image} alt={`Image ${index}`} />
                </div>
              ))}
            </Carousel>
          </div>
        </div>
      </div>

      <div>
        {/* Courses Program Section */}
        <div className="default-padding bg-light py-5">
          <div className="container" data-aos="fade-up">
            <h2 className="fw-bold text-center mb-4 text-uppercase">
              PES MIBS Post Graduate and Under Graduate Programs
            </h2>

            <div className="row g-4 justify-content-center">
              {/* MCA Card */}
              <div className="col-md-4" style={{ color: "#ffffffff" }}>
                <div
                  className="bg-custom shadow rounded p-3 h-100"
                  style={{
                    backgroundColor: "#0b2e55ff",
                    color: "white",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <h4
                    className="fw-bold mb-2"
                    style={{
                      fontSize: "30px",
                      // marginBottom: "8px",
                      color: "white",
                    }}
                  >
                    MCA Program
                  </h4>
                  <p
                    className=" mb-2"
                    style={{
                      fontSize: "19px",
                      color: "wheat",
                      fontWeight: "500",
                    }}
                  >
                    POST GRADUATE · 2 YEARS
                  </p>
                  <h6
                    className="mt-2 fw-semibold"
                    style={{ marginBottom: "5px", color: "wheat" }}
                  >
                    ELIGIBILITY:
                  </h6>
                  <p style={{ fontSize: "17px" }}>
                    Bachelor’s Degree with Mathematics
                  </p>
                  <ul
                    className="ps-5 text-uppercase"
                    style={{ fontSize: "18px" }}
                  >
                    <li>Data Science</li>
                    <li>Mobile Applications</li>
                    <li>IOT</li>
                    <li>AI & ML</li>
                    <li>Mini Project in each Semester</li>
                  </ul>
                  <p
                    className="mt-2  fst-italic"
                    style={{ fontSize: "0.95rem", color: "wheat" }}
                  >
                    The programme offers On-Job Training and research projects
                    to enhance practical knowledge and innovation skills.
                  </p>
                </div>
              </div>

              {/* MBA Card */}
              <div className="col-md-4" style={{ color: "#ffffffff" }}>
                <div
                  className="bg-custom shadow rounded p-3 h-100"
                  style={{
                    backgroundColor: "#0b2e55ff",
                    color: "white",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <h4
                    className="fw-bold"
                    style={{
                      fontSize: "30px",
                      marginBottom: "8px",
                      color: "white",
                    }}
                  >
                    MBA Program
                  </h4>
                  <p
                    className=" mb-1"
                    style={{
                      fontSize: "19px",
                      color: "wheat",
                      fontWeight: "500",
                    }}
                  >
                    POST GRADUATE · 2 YEARS
                  </p>
                  <h6
                    className="mt-3 fw-semibold"
                    style={{ marginBottom: "7px", color: "wheat" }}
                  >
                    ELIGIBILITY:
                  </h6>
                  <p style={{ fontSize: "17px" }}>Graduation in Any Stream</p>
                  <ul
                    className="ps-5 text-uppercase"
                    style={{ fontSize: "18px" }}
                  >
                    <li>Marketing</li>
                    <li>Finance</li>
                    <li>Human Resource</li>
                    <li>Operations and Supply Chain</li>
                    <li>Business Analytics</li>
                  </ul>
                  <p
                    className="mt-1  fst-italic"
                    style={{ fontSize: "0.95rem", color: "wheat" }}
                  >
                    We offer On-Job Training, Field Projects, and Research
                    Projects tailored specifically for MBA students.
                  </p>
                </div>
              </div>

              {/* BCA Card */}
              <div className="col-md-4" style={{ color: "#ffffffff" }}>
                <div
                  className="bg-custom shadow rounded p-3 h-100"
                  style={{
                    backgroundColor: "#0b2e55ff",
                    color: "white",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <h4
                    className="fw-bold"
                    style={{
                      fontSize: "30px",
                      // marginBottom: "4px",
                      color: "white",
                    }}
                  >
                    BCA Program
                  </h4>
                  <p
                    className=" mb-1"
                    style={{
                      fontSize: "19px",
                      color: "wheat",
                      fontWeight: "500",
                    }}
                  >
                    UNDER GRADUATE · 3/4 YEARS
                  </p>
                  <h6
                    className="mt-1 fw-semibold"
                    style={{ marginBottom: "5px", color: "wheat" }}
                  >
                    ELIGIBILITY:
                  </h6>
                  <p style={{ fontSize: "17px" }}>12th with any stream</p>
                  <ul
                    className="ps-5 text-uppercase"
                    style={{ fontSize: "18px" }}
                  >
                    <li>Computer Programming</li>
                    <li>Web Technology</li>
                    <li>Database Analysis</li>
                    <li>Networking</li>
                    <li>Mini Project in each Semester</li>
                  </ul>
                  <p
                    className="mt-2  fst-italic"
                    style={{ fontSize: "0.95rem", color: "wheat" }}
                  >
                    The programme offers projects to enhance practical knowledge
                    and innovation skills.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <Grid container className="newsCard mt-4 px-2 box"> */}
        {/* <Grid md={4} xs={12} className="px-3 box" data-aos="fade-right">
            <h5 className="text-bold decorated mb-4">NEWS ANNOUNCEMENT</h5>
            <NewsAnnouncementText />
            <Link to={"/NewsAnnouncementPage"}>
              <h5 className="ViewMore">View All News</h5>
            </Link>
          </Grid>
          <Grid md={4} xs={12} className="px-3 box" data-aos="fade-up">
            <h5 className="text-bold decorated mb-4">NOTICE BOARD</h5>
            <NoticeBoardText />
            <Link to={"/NoticeBoardPage"}>
              <h5 className="ViewMore">View All Notices</h5>
            </Link>
          </Grid>
          <Grid md={4} xs={12} className="px-3 box" data-aos="fade-left">
            <h5 className="text-bold decorated mb-4">UPCOMING EVENT</h5>
            <UpcomingEvents />
            <Link to={"/UpcomingEventPage"}>
              <h5 className="ViewMore">View All Events</h5>
            </Link>
          </Grid> */}
        {/* <img src={bannerimg} alt="banner img" /> */}
        {/* </Grid> */}
      </div>
      {/* Temstimonial */}
      <div className="default-padding">
        <div className="container">
          <div className="text-center" data-aos="fade-up">
            <h5 className="title-text">TESTIMONIALS</h5>
            <h2>Our Students Review</h2>
          </div>
          <div className="default-padding-top" data-aos="zoom-in">
            <TestimonialSlick />
          </div>
        </div>
      </div>

      {/* Why Choose us*/}
      <div className="default-padding bg-light">
        <div className="container">
          <div className="text-center" data-aos="fade-up">
            <h2 className="fw-bold title-text">Excellence Spotlight </h2>
            {/* <h5 className="title-text">WELCOME TO</h5> */}
            {/* <h2>Modern Institute Of Business Studies</h2> */}
          </div>

          {/* new latest */}
          <Grid container spacing={2} style={{ marginTop: "20px" }}>
            {/* Left side: Video thumbnail */}
            {/* <Grid item xs={12} md={5}>
              <div style={{ position: "relative", height: "100%" }}>
                <img
                  src="assets/img/1.jpg"
                  alt="Video Thumbnail"
                  style={{
                    width: "100%",
                    height: "360px",
                    objectFit: "cover",
                    borderRadius: "8px",
                  }}
                />
                <VideoPlayer />
              </div>
            </Grid> */}

            {/* Right side: Auto-scrolling testimonials */}
            <Grid item xs={12} md={12}>
              {" "}
              {/*md={7}*/}
              <div
                ref={scrollRef}
                style={{
                  height: "360px",
                  overflowX: "auto", // ✅ allow manual scroll
                  display: "flex",
                  gap: "15px",
                  whiteSpace: "nowrap",
                  scrollbarWidth: "none", // hide scrollbar in Firefox
                  msOverflowStyle: "none", // hide scrollbar in IE/Edge
                }}
              >
                {[...placedStudents, ...placedStudents].map(
                  (student, index) => (
                    <img
                      key={index}
                      src={student}
                      alt={`student-${index}`}
                      style={{
                        height: "100%",
                        width: "auto",
                        borderRadius: "8px",
                        flexShrink: 0,
                        objectFit: "cover",
                      }}
                    />
                  ),
                )}
              </div>
            </Grid>
          </Grid>

          {/* new latest end */}

          {/* new */}
          {/* <Grid container spacing={2} style={{ marginTop: "20px" }}> 
            <Grid item xs={12} md={5}>
              <div style={{ position: "relative", height: "100%" }}>
                <img
                  src="assets/img/1.jpg"
                  alt="Video Thumbnail"
                  style={{
                    width: "100%",
                    height: "320px",
                    objectFit: "cover",
                    borderRadius: "8px",
                  }}
                />
                <VideoPlayer />
              </div>
            </Grid>
            <Grid item xs={12} md={7}>
              {/* new placed studnet 
               <div 
                ref={scrollRef}
                style={{
                  maxHeight: "320px",
                  overflowY: "auto",
                  paddingRight: "8px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "15px",
                }}
              >
                {placedStudents.map((student, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      backgroundColor: "white",
                      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                      padding: "12px",
                      borderRadius: "8px",
                      gap: "16px",
                    }}
                  >
                    <img
                      src={student.img}
                      alt={student.name}
                      style={{
                        width: "200px",
                        height: "130px",
                        borderRadius: "50%",
                        objectFit: "cover",
                        flexShrink: 0,
                      }}
                    />
                    <div>
                      <h5 style={{ margin: "0 0 4px 0" }}>{student.name}</h5>
                      <p style={{ margin: "0 0 2px", color: "#666" }}>
                        Placed at: <strong>{student.company}</strong>
                      </p>
                      <p style={{ margin: 0, color: "#666" }}>
                        Batch: {student.batch}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </Grid>
          </Grid> */}
          {/* new end */}

          {/* old start */}
          {/* <Grid container className="why-choseus-area default-padding-top">
            <Grid xs={12} md={4} className="py-2">
              <div className="position-relative my-1">
                <img
                  src="assets/img/1.jpg"
                  alt="Thumb"
                  style={{ maxWidth: "100%", height: 320 }}
                />
                <VideoPlayer />
              </div>
            </Grid>
            <Grid container md={8} className="why-choseus-area px-4">
              <Grid xs={12} md={4} className="px-2 py-3">
                <div className="item">
                  <span>01</span>
                  <i className="flaticon-library" />
                  <Link>
                    <h5 className="my-4">Campus Life</h5>
                  </Link>
                  <p>Absolute required of reserved in offering no.</p>
                  <ul>
                    <li>Point One</li>
                    <li>Point Two</li>
                    <li>Point Three</li>
                  </ul>
                </div>
              </Grid>
              <Grid xs={12} md={4} className="px-2 py-3">
                <div className="item">
                  <span>01</span>
                  <i className="flaticon-library" />
                  <Link>
                    <h5 className="my-4">Campus Life</h5>
                  </Link>
                  <p>Absolute required of reserved in offering no.</p>
                  <ul>
                    <li>Point One</li>
                    <li>Point Two</li>
                    <li>Point Three</li>
                  </ul>
                </div>
              </Grid>
              <Grid xs={12} md={4} className="px-2 py-3">
                <div className="item">
                  <span>01</span>
                  <i className="flaticon-library" />
                  <Link>
                    <h5 className="my-4">Campus Life</h5>
                  </Link>
                  <p>Absolute required of reserved in offering no.</p>
                  <ul>
                    <li>Point One</li>
                    <li>Point Two</li>
                    <li>Point Three</li>
                  </ul>
                </div>
              </Grid>
            </Grid>
          </Grid>  */}
          {/* old end */}
        </div>
      </div>

      {/* Vision */}
      <div className="py-5">
        <div className="container" data-aos="fade-up">
          {/* Title */}
          <div className="text-center mb-3">
            <h3 className="fw-bold text-uppercase" style={{ color: "#A70606" }}>
              Our Vision
            </h3>
            <div
              className="bg-secondary rounded-pill mx-auto mt-2"
              style={{ height: "3px", width: "60px" }}
            ></div>
          </div>

          {/* Statement Box with Stronger Shadow */}
          <div
            className="bg-white border-start border-4 border-primary mx-auto px-4 px-md-5 py-4 rounded"
            style={{
              maxWidth: "900px",
              fontSize: "1.15rem",
              lineHeight: "1.9",
              fontWeight: 500,
              boxShadow: "0 6px 10px rgba(0, 0, 0, 0.3)", // stronger custom shadow
            }}
          >
            <p className="mb-0 text-secondary fst-italic">
              " We nurture competent techno-managerial professionals by imbibing
              holistic approach to serve the global society."
            </p>
          </div>
        </div>
      </div>

      {/* Courses */}
      {/* <div className="default-padding bg-light pt-0">
        <div className="container">
          <div className="container text-center" data-aos="fade-up">
            <h5 className="title-text">SPECIALIZATIONS OFFERED</h5>
            <h2>Here is our Top Courses</h2>
          </div>
          <div className="default-padding-top" data-aos="zoom-in">
            <Grid container className="course-box">
              <Grid xs={12} md={5} className="course-box-first px-2">
                <h2 className="fw-bold mb-4">
                  Select your favorite subject from best categories
                </h2>
                <p>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Harum
                  laudantium autem saepe sint ex placeat nihil laboriosam fugit,
                  quod nisi dolor rem cupiditate minus animi laborum voluptatem
                  assumenda. Neque, suscipit!
                </p>
                <button className="btn btn-main">View</button>
              </Grid>
              <Grid xs={12} md={7}>
                <CourseSlick />
              </Grid>
            </Grid>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default Home;
